import { ComponentClass } from 'react';
export { ComponentClass };
import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "TimePanelCalendar", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded components
export const CalendarList = createLazyComponent(lazyModule, m => m.CalendarList);
export { clickAgendaEvent, doubleClickAgendaEvent, rightClickAgendaEvent } from 'owa-agenda-events';
